module.exports = __webpack_public_path__ + "static/media/bd.7d936d62.svg";